import { isNil } from 'lodash';
import { DEFAULT_ARROW_PROPS } from '../../../../../Shape/config/Shapes';

const isDouble = shape => (isNil(shape.get('isDouble')) ? DEFAULT_ARROW_PROPS.isDouble : shape.get('isDouble'));

export default isDouble;
